import React from "react";
import { Box, Grid2, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";

import dashboard from "../../../../Images/PTW/dashboard.png";
import formList from "../../../../Images/PTW/formlist.png";
import formPage from "../../../../Images/PTW/formpage.png";
import wave from "../../../../Images/aboutUsBg.jpg";
// import wave from "../../../../Images/aboutUsBg.jpg";
import { commonCss } from "../../../../CssStyle/commonCss";
import WaveBackground from "../../../../Component/WaveBackground";
import { ArrowForward } from "@mui/icons-material";

const PTW = () => {
  return (
    <Grid2 container spacing={"2rem"} >
     <WaveBackground menu={"Our Products"} title={"e-PTW"} description={"Streamlined Digital Permit-To-Work Management System"}/>
    

     <Grid2 container justifyContent={"center"}>
           <Grid2 container size={12} spacing={"1rem"} sx={{padding:{xs:"1.5rem",md:"0 3rem 3rem 3rem"},maxWidth:{xs:"auto",xl:"2000px"}}} alignItems={"center"} mt="-10%" >
             <Grid2 container size={{xs:12,md:6}}  justifyContent={{xs:"center",md:"flex-start"}}>
            <img src={dashboard} style={{width:'85%',height:"100%"}}/>
        </Grid2>
        <Grid2 size={{xs:12,md:6}} sx={{pr:{xs:0,md:"3rem",fontFamily: 'Roboto, Arial, sans-serif',}}}>
          <Typography variant="h2" sx={{fontSize:{xs:"35px",md:"40px"},textAlign:{xs:"center",md:"left"},fontWeight:700,fontFamily:"inherit"}}>Permit To Work Web App </Typography>
            <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>e-PTW</span> Management Web App is a digital solution designed to streamline and improve the process of managing work permits within an organization, ensuring compliance with safety regulations and industry standards. The app serves as a centralized platform where users can create, track, and approve permits for high-risk tasks, ensuring that safety protocols are followed before, during, and after the work is conducted.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography>
            <List sx={{'& .MuiListItemText-primary': {
              fontFamily: 'Roboto, sans-serif', 
              fontSize:"1rem",
              fontWeight:600
            },
            display:"flex",
            columnGap:"1rem",
            flexWrap:"wrap",
            width:'100%',
            mt:1,
            }} >
             
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText >Permit Creation and Approval
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Real-Time Tracking and Notifications
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Risk Assessment Integration
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Automated Notifications</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Role-Based Access Control
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Audit Trails and Reporting</ListItemText>
                </ListItem>
            </List>
        </Grid2>
     </Grid2>
     </Grid2>
     <Grid2 container justifyContent={"center"} sx={{background:commonCss.backgroundGray}} >
          <Grid2 container size={12} spacing={"1rem"} sx={{padding:{xs:"1.5rem",md:"3rem"},maxWidth:{xs:"auto",md:"2000px"}}} alignItems={"center"}>
     <Grid2 size={{xs:12,md:6}} sx={{pl:{xs:0,md:"3rem",fontFamily: 'Roboto, Arial, sans-serif',}}}>
          <Typography variant="h2" sx={{fontSize:{xs:"35px",md:"40px"},fontWeight:700,fontFamily:"inherit"}}>A smart digital solution for managing and automating permit-to-work processes efficiently and securely.
</Typography>
            <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>Why Use e-PTW?
</Typography>
            
            {/* <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography> */}
            <List sx={{'& .MuiListItemText-primary': {
              fontFamily: 'Roboto, sans-serif', 
              fontSize:"1rem",
              fontWeight:600
            },
            display:"flex",
            columnGap:"1rem",
            flexWrap:"wrap",
            width:'100%',
            mt:4,
            }} >
             
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText >To enhance workplace safety by ensuring proper authorization for high-risk tasks.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>To streamline and digitize the traditional paper-based permit system for improved efficiency.
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>To maintain clear accountability with a detailed audit trail for compliance purposes.
                  </ListItemText>
                </ListItem>
              
            </List>
        </Grid2>
        <Grid2 container size={{xs:12,md:6}}  justifyContent={{xs:"center",md:"flex-end"}}>
            <img src={formList} style={{width:'85%',height:"100%"}}/>
        </Grid2>
      
     </Grid2>
     </Grid2>
       <Grid2 container justifyContent={"center"}>
          <Grid2 container size={12} spacing={"1rem"} sx={{padding:{xs:"1.5rem",md:"3rem"},maxWidth:{xs:'auto',xl:"2000px"}}} alignItems={"center"}  >
        <Grid2 container size={{xs:12,md:6}}  justifyContent={{xs:"center",md:"flex-start"}}>
            <img src={formPage} style={{width:'85%',height:"100%"}}/>
        </Grid2>
        <Grid2 size={{xs:12,md:6}} sx={{pr:{xs:0,md:"3rem",fontFamily: 'Roboto, Arial, sans-serif',}}}>
          <Typography variant="h2" sx={{fontSize:{xs:"35px",md:"40px"},fontWeight:700,fontFamily:"inherit"}}>Benefits</Typography>
            {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
            <List sx={{'& .MuiListItemText-primary': {
              fontFamily: 'Roboto, sans-serif', 
              fontSize:"1.1rem",
              fontWeight:400
            },
            display:"flex",
            columnGap:"1rem",
            flexWrap:"wrap",
            width:'100%',
            mt:1,
            }} >
             
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText >Ensures all safety protocols are followed by automating checks and approvals.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Reduces manual paperwork and speeds up permit approvals.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Provides real-time insights into ongoing work permits</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Improves team communication with task tracking and alerts.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Safely stores all permit records for easy access and audits.
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Interactive dashboards </ListItemText>
                </ListItem>
            </List>
        </Grid2>
     </Grid2>
     </Grid2>
    </Grid2>
  );
};

export default PTW;
